import { useCallback } from 'react';
import { ONE_DAY } from 'shared/constants/NumberConstants';
import { useJSONLocalStore } from 'shared/helpers/Store';
import { NotificationType } from './NotificationDTO';

const SUBSCRIPTION_NOTIFICATIONS_DISMISSED_AT =
  'subscription_notifications_dismissed_at';

const DAILY_NOTIFICATIONS = new Set<NotificationType>([
  'subscription_payment_failed',
  'subscription_card_expiring',
]);

const DEFAULT_STATE: Partial<Record<NotificationType, string>> = {};

export function useSubscriptionNotificationsDismissal() {
  const { storeValue, updateStoreValue } = useJSONLocalStore(
    SUBSCRIPTION_NOTIFICATIONS_DISMISSED_AT,
    DEFAULT_STATE,
  );

  const isDismissed = useCallback(
    (notificationType: NotificationType) => {
      const dismissedAt = storeValue[notificationType];

      return (
        !!dismissedAt && Date.now() - new Date(dismissedAt).getTime() < ONE_DAY
      );
    },
    [storeValue],
  );

  const dismiss = (notificationType: NotificationType) => {
    if (!DAILY_NOTIFICATIONS.has(notificationType)) {
      return;
    }

    updateStoreValue((prev) => ({
      ...prev,
      [notificationType]: new Date().toISOString(),
    }));
  };

  return { isDismissed, dismiss };
}
